$(document).ready(function(){
	$('.btn_cookies').click(function() {
		var values;
		$.ajax({
			type: "GET",
			url: baseURL + "/accept-cookies-policy",
			data: values,
			success: function(html) {
				$('.box_cookies').hide();
			}
		});
	});
 });

$(document).ready(function () {

	$(document).on('click', '.login-register-form', function() {
		$('.login-register-form').removeClass('active');
		$(this).addClass('active');

		var form = $(this).data('form');
		$('.login-register-form-container').hide();
		$('#'+form).show();
	});


     $(".dropdown-produse li").hover(function(){
         $(".dropdown-produse li").removeClass("active");
         $(this).addClass("active");
     });

     $(".produse-button").click(function(){
         $(".dropdown-produse").toggleClass("opened");
     });

     if ($('.slider-oferte').length > 0) {
        $('.slider-oferte').slick({
            centerMode: true,
            centerPadding: '5px',
            slidesToShow: 5,
            // adaptiveHeight: true,
            // infinite: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    arrows: true,
                //    centerMode: true,
                //    centerPadding: '30px',
                    slidesToShow: 3
                    }
                },
                {
                breakpoint: 768,
                settings: {
                    arrows: true,
                //  centerMode: true,
                //  centerPadding: '30px',
                    slidesToShow: 2
                }
                },
                {
                breakpoint: 480,
                settings: {
                    arrows: false,
                //  centerMode: true,
                //  centerPadding: '30px',
                    slidesToShow: 1,
                    dots: true
                }
                }
            ]
        });

     }

     if ($('.swiper-oferte').length > 0)
     {
         const swiperOffers = new Swiper('.swiper-oferte', {
            // Optional parameters
            slidesPerView: 1,
            spaceBetween: 11,
            centeredSlides: true,
            // loop: true,
            centerInsufficientSlides: true,
            centeredSlidesBounds: true,
            observer: true,

            // Navigation arrows
            navigation: {
              nextEl: '.swiper-offer-next',
              prevEl: '.swiper-offer-prev',
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                  slidesPerView: 3,
                  spaceBetween: 30
                },
                // when window width is >= 1024px
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 11
                },
                1280: {
                  slidesPerView: 5,
                  spaceBetween: 11
                }
            }
        });
     }

    if ($('.swiper-offer-category').length > 0)
    {
         const swiper = new Swiper('.swiper-offer-category', {
            // Optional parameters
            slidesPerView: 1,
            spaceBetween: 11,
            centeredSlides: true,
            loop: true,

            // Navigation arrows
            navigation: {
              nextEl: '.swiper-offer-category-next',
              prevEl: '.swiper-offer-category-prev',
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                  slidesPerView: 3,
                  spaceBetween: 30
                },
                // when window width is >= 1024px
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 11
                },
                1280: {
                  slidesPerView: 5,
                  spaceBetween: 11
                }
            }
        });
    }

    if ($('.swiper-blog').length > 0)
    {
         const swiperBlog = new Swiper('.swiper-blog', {
            // Optional parameters
            slidesPerView: 1,
            spaceBetween: 10,

            // Navigation arrows
            navigation: {
              nextEl: '.swiper-blog-next',
              prevEl: '.swiper-blog-prev',
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                  slidesPerView: 4,
                  spaceBetween: 30
                },
                // when window width is >= 1024px
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 11
                },
            }
        });
    }

    if ($('.swiper-brands-result').length > 0)
    {
         const swiper = new Swiper('.swiper-brands-result', {
            // Optional parameters
            slidesPerView: 1,
            spaceBetween: 11,
            centeredSlides: true,
            loop: true,

            // Navigation arrows
            navigation: {
              nextEl: '.swiper-brands-result-next',
              prevEl: '.swiper-brands-result-prev',
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                  slidesPerView: 3,
                  spaceBetween: 30
                },
                // when window width is >= 1024px
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 11
                },
                1280: {
                  slidesPerView: 5,
                  spaceBetween: 11
                }
            }
        });
    }


     if ($('.slider-brands').length > 0) {
         $(".slider-brands").slick({
             slidesToShow: 5,
             slidesToScroll: 1,
             arrows: true,
             responsive: [
               {
                 breakpoint: 768,
                 settings: {
                   arrows: false,
                   centerPadding: '30px',
                   slidesToShow: 3
                 }
               },
               {
                 breakpoint: 480,
                 settings: {
                   arrows: false,
                   centerPadding: '15',
                   slidesToShow: 3
                 }
               }
             ]
         });
     }

     if ($('.swiper-brand').length > 0)
     {
          const swiperBrand = new Swiper('.swiper-brand', {
             // Optional parameters
             slidesPerView: "auto",
            //  slidesPerView: 5,
             spaceBetween: 11,
             centeredSlides: true,
             centeredSlidesBounds: true,
             centerInsufficientSlides: true,
            //  loop: true,

             // Navigation arrows
             navigation: {
               nextEl: '.swiper-brand-next',
               prevEl: '.swiper-brand-prev',
             },
             breakpoints: {
                 // when window width is >= 768px
                 768: {
                   slidesPerView: 3,
                   spaceBetween: 30
                 },
                 // when window width is >= 1024px
                 1024: {
                   slidesPerView: 5,
                   spaceBetween: 11
                 }
             }
         });
         swiperBrand.on('slideChange', function (swiper) {
            let index_currentSlide = swiper.realIndex;
            let currentSlide = swiper.slides[index_currentSlide]
            $(currentSlide.firstElementChild).tab('show');
        });
     }


     if ($('.swiper-category').length > 0)
     {
          const swiperCategory = new Swiper('.swiper-category', {
             // Optional parameters
             slidesPerView: "auto",
            //  slidesPerView: 5,
             spaceBetween: 11,
            //  centeredSlides: true,
            //  centeredSlidesBounds: true,
            //  centerInsufficientSlides: true,
            //  loop: true,

             // Navigation arrows
             navigation: {
               nextEl: '.swiper-category-next',
               prevEl: '.swiper-category-prev',
             },
             breakpoints: {
                 // when window width is >= 768px
                 768: {
                   slidesPerView: 3,
                   spaceBetween: 30
                 },
                 // when window width is >= 1024px
                 1024: {
                   slidesPerView: 5,
                   spaceBetween: 11
                 }
             }
         });
         swiperCategory.on('slideChange', function (swiper) {
            let index_currentSlide = swiper.realIndex;
            let currentSlide = swiper.slides[index_currentSlide]
            $(currentSlide.firstElementChild).tab('show');
        });
    }

    // SELECT2
    if ($('.select-sort').length > 0)
    {
        $('.select-sort').select2({
            minimumResultsForSearch: Infinity
        });
    }
    // SELECT2

     if ($('.slider-brands-result').length > 0) {
         $('.slider-brands-result').slick({
               centerMode: true,
               centerPadding: '60px',
               slidesToShow: 5,
               arrows: false,
               responsive: [
                 {
                     breakpoint: 1024,
                     settings: {
                       dots: true,
                       centerMode: true,
                       centerPadding: '30px',
                       slidesToShow: 3
                     }
                 },
                 {
                   breakpoint: 768,
                   settings: {
                     dots: true,
                     centerMode: true,
                     centerPadding: '30px',
                     slidesToShow: 2
                   }
                 },
                 {
                   breakpoint: 480,
                   settings: {
                     dots: false,
                     centerMode: true,
                     centerPadding: '30px',
                     slidesToShow: 1,
                     dots: true
                   }
                 }
               ]
             });
     }

     if ($('.slider-testimonials').length > 0) {
         $(".slider-testimonials").slick();
     }

     $(".tabs-container-home .wrap").click(function(){
         $(".tabs-container-home .wrap").removeClass("selected");
         $(this).addClass("selected");
     });



     $(".produse-icon").click(function(){
         $(".menu-header-top-fixed").toggleClass("show");
         $(".menu-header-top-fixed ul").removeClass("show");

     });

     $(".menu-header-top-fixed .first-ul a").hover(function(){
         $(".menu-header-top-fixed .second-ul").addClass("show");
     })

     $(".menu-header-top-fixed .second-ul a").hover(function(){
         $(".menu-header-top-fixed .third-ul").addClass("show");
     })

     $(".icon-log-join").click(function(){
         $(".log-in-join-wrap").toggleClass("open");
     });

     $(".produs .see-more").click(function(){
         $(".produs .more-description").toggleClass("hide");

         if($(".produs .more-description").hasClass("hide")) {
             $(".produs .see-more").html("Vezi mai mult <i class='fal fa-plus'></i>");
             $(".produs .descriere .overlay").show();
         } else {
             $(".produs .see-more").html("Vezi mai putin <i class='fal fa-minus'></i>");
             $(".produs .descriere .overlay").hide();
         }
     });

     $(".wrap-selection.two .radion-btn-new").click(function(){
         $(".wrap-selection.two .radion-btn-new").removeClass("selected");
         $(this).addClass("selected");

         if($(".wrap-selection.two").find(".radion-btn-new").hasClass("selected") ) {
             $('.wrap-selection.two .radio-btn').each(function(){
                 $(this).prop("checked", !$(this).prop("checked"));
             });
         }
     });

     $(".left-filters label").click(function(){
         $(this).toggleClass("selected");
     });

     $(".label-checkbox").click(function(){
		var checkbox = $(this).parent().find('input:checkbox');
		if ($(this).hasClass("selected-checkbox")) {
			console.log('false');
			$(this).removeClass("selected-checkbox");
			checkbox.attr("checked", false);
		} else {
			console.log('marcat');
			$(this).addClass("selected-checkbox");
			checkbox.attr("checked", "checked");
		}
     });

     $(".comenzi .show-more-less").click(function(){
		var id= $(this).data('id');

		if ($('#order-products-' + id).css('display') == 'none') {
			$('#order-products-' + id).css('display', 'block');
			$("#order-" +  id).find(".show-more-less").html("ASCUNDE DETALII");
		} else {
			$('#order-products-' + id).css('display', 'none');
			$("#order-" +  id).find(".show-more-less").html("DETALII COMANDA");
		}
     });

     $(".cart-icon").click(function(){
         $(".preview-cos").show();
         $("body").addClass("overflow-hidden");
     });

     $(".close-cos-preview").click(function(){
         $(".preview-cos").hide();
         $("body").removeClass("overflow-hidden");
     });

    //  $(".hamburger").click(function(){
    //     $(".main-menu-mobile").toggleClass("open");
    //     $("body").toggleClass("overflow-hidden");
    //     if($(".main-menu-mobile").hasClass("open")) {
    //        $(".hamburger").html("<i class='fal fa-times'></i>");
    //    } else {
    //        $(".hamburger").html("<i class='fal fa-bars'></i>");
    //    }
    // });

    $(".categ-li-mob").click(function(){
         $(this).find(".submenu-mobile").toggleClass("open");
     });

     $(".categ-li-mob.has-submenu").click(function(){
         $(this).find("a").toggleClass("opened");
     });

     $(".filters-icon-mobile").click(function(){
         $(".left-filters").toggleClass('active');
         $(".overlay-mobile").show();
         $("body").addClass("overflow-hidden");
     });

     $(".close-filters-mobile").click(function(){
         $(".left-filters").toggleClass('active');
         $(".overlay-mobile").hide();
         $("body").removeClass("overflow-hidden");
     });


 });

//  $(window).scroll(function(){
//      if ($(this).scrollTop() > 91) {
//          $(".main-menu-header").hide();
//          $(".produse-icon").show();
//          $("header").addClass("scrolled");
//          $(".preview-cos").addClass("small-header");
//      } else {
//          $(".main-menu-header").show();
//          $(".produse-icon").hide();
//          $("header").removeClass("scrolled");
//          $(".preview-cos").removeClass("small-header");
//      }
//  });



// WEBPACK FOOTER //
// ./resources/assets/js/regular/javascript.js